module.exports = __webpack_public_path__ + "static/2-83a950514c1bd45ee991d8e199e2e2dd.png";